// export default {
//   apiKey: 'AIzaSyCfFq_so9mdR4Oj81SqYG8BbWLa0Bingys',
//   googleSheet: ['https://sheets.googleapis.com/$discovery/rest?version=v4'],
//   spreadsheetId: '11K03CSzkkVi6oaCseVNAZyFivc-ubfd0T2pc6d6KVgw'
// };


// spreadsheetId: '1QrcnCvPwFMGjLiVWOOZ7TsLulqBn_qW79DR2FJ5KBjo'   -- test
export default {
  apiKey: 'AIzaSyCfFq_so9mdR4Oj81SqYG8BbWLa0Bingys',
  googleSheet: ['https://sheets.googleapis.com/$discovery/rest?version=v4'],
  spreadsheetIdMen: '1S3829_GP2jjGfnIEz3Oyrl4_XkVqf_OgBS_ixB71BIQ',
  spreadsheetIdWomen: '1DiJcGfzU_UnLB6nYxmOuFFczCyVjQDf3SsnB0XY3POM'
};